import { lazy } from "react";
import { Users } from "lucide-react";
import type { AdminModule } from "../types";

const UsersSearch = lazy(() => import("./pages/UsersSearch").then((m) => ({ default: m.UsersSearch })));
const UserDetail = lazy(() => import("./pages/UserDetail").then((m) => ({ default: m.UserDetail })));

export const usersModule: AdminModule = {
  key: "users",
  label: "Users",
  description: "Find a person, check their access, suspend or impersonate.",
  group: "customers",
  icon: Users,
  requiredPermission: "admin.users.read",
  routes: [
    { path: "search", label: "Search", element: <UsersSearch /> },
    // :id has no label — hidden from sub-nav, only reachable from search row.
    { path: ":id", element: <UserDetail /> },
  ],
};
